/**
 * 权限 Store
 * @author LiQingSong
 */
import { asyncRoutes, constantRoutes } from '@/router'

/**
 * 根据 meta.role 判断当前用户是否有权限
 * @param roles 用户的权限
 * @param route 路由
 */
function hasPermission(role, route) {
  if (route.meta && route.meta.roles) {
    // return permissions.some(per => route.meta.roles.includes(per.name))
    return route.meta.roles.includes(role)
  } else if (route.meta && route.meta.exRoles) {
    return !route.meta.exRoles.includes(role)
  } else {
    return true
  }
}

/**
 * 根据权限 - 递归过滤异步路由
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, permissions) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(permissions, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, permissions)
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, { routes, cRoutes }) => {
    state.addRoutes = routes
    state.routes = cRoutes.concat(routes)
  }
}

const actions = {
  // { commit }
  generateRoutes({ commit }, { role, companyId }) {
    return new Promise(resolve => {
      let asyncRoutes2 = asyncRoutes.filter(r =>
        r.meta && r.meta.companyId ? +r.meta.companyId === +companyId : true
      )
      let accessedRoutes
      let cRoutes
      if (role && role.name === 'admin') {
        accessedRoutes = asyncRoutes2 || []
        cRoutes = constantRoutes || []
      } else {
        accessedRoutes = filterAsyncRoutes(asyncRoutes2, role.name)
        cRoutes = filterAsyncRoutes(constantRoutes, role.name)
      }
      commit('SET_ROUTES', { routes: accessedRoutes, cRoutes })
      resolve(asyncRoutes || [])
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
